export default () => {
  const otherTreatmentTrue = $("#incident_report_other_treatment_type_true");
  const otherTreatmentFalse = $("#incident_report_other_treatment_type_false");

  const otherTreatmentTextFields = $("#incident_report_other_treatment_type_text");

  if (otherTreatmentTrue.is(":checked")) {
    otherTreatmentTextFields.show();
  } else if (otherTreatmentFalse.is(":checked")) {
    otherTreatmentTextFields.hide();
  } else {
    otherTreatmentTextFields.hide();
  }
  otherTreatmentFalse.on("click", function () {
    otherTreatmentTextFields.toggle(this.checked);
  });
  otherTreatmentTrue.on("click", () => {
    otherTreatmentFalse.not("#incident_report_other_treatment_type_true").prop("checked", false);
    otherTreatmentTextFields.show();
  });
  otherTreatmentFalse.on("click", () => {
    otherTreatmentTrue.not("#incident_report_other_treatment_type_false").prop("checked", false);
    otherTreatmentTextFields.hide();
  });
};
